import React, { useState, useEffect } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";

const urlsToExclude = [
  "www.mozilla.org",
  "www.google.com",
  "www.facebook.com",
  "twitter.com",
  "policies.google.com",
  "www.clarkassociatesinc.biz",
  "www.lancastertableandseating.com",
  "www.instagram.com",
  "www.youtube.com",
  "www.tiktok.com",
  "www.pinterest.com",
  "pinterest.com",
  "get.adobe.com",
  "youtu.be",
  "webstaurantstore.com",
  "www.webstaurantstore.com",
  "dev.webstaurantstore.com",
  "www.dev.webstaurantstore.com",
  "versahub.com",
  "wwww.versahub.com",
  "dev.versahub.com",
  "www.dev.versahub.com",
  "cdnimg.webstaurantstore.com",
  "tfs.clarkinc.biz",
  "teams.microsoft.com",
  "apps.apple.com",
  "play.google.com",
  "www.firstbankcard.com",
  "www.card.fnbo.com",
];

const shouldShowModal = (link: HTMLAnchorElement) => {
  return (
    link.host &&
    link.host !== window.location.host &&
    !urlsToExclude.includes(link.host)
  );
};

const visitLink = (link: string) => {
  Modal.close("external-link-modal");
  window.open(link, "_blank");
};

const headerTitleStyle = `
  h5.zest-modal-header-title {
    margin-bottom: 0;
  }`;

function ExternalLinkModal() {
  const [externalLink, setExternalLink] = useState("");

  const onLinkClick = (e: Event) => {
    e.preventDefault();
    let aLink = e.target;
    if (!(aLink instanceof HTMLAnchorElement) && aLink instanceof Element) {
      aLink = aLink.parentElement;
    }
    if (aLink instanceof HTMLAnchorElement) {
      setExternalLink(aLink.href);
      Modal.open("external-link-modal");
    }
  };

  useEffect(() => {
    let links: (() => void)[] = [];

    const setupLinks = () => {
      // remove existing event listeners
      links.forEach((fn) => fn());
      // setup new links array to store event listeners for cleanup
      links = [];

      const externalLinks = document.getElementsByTagName("a");

      for (const link of externalLinks) {
        if (shouldShowModal(link)) {
          link.addEventListener("click", onLinkClick);

          links.push(() => link.removeEventListener("click", onLinkClick));
        }
      }
    };

    setupLinks();

    window.addEventListener("resourcesLoaded", setupLinks);

    return () => {
      window.removeEventListener("resourcesLoaded", setupLinks);

      links.forEach((fn) => fn());
    };
  }, []);

  return (
    <>
      <style type="text/css">{headerTitleStyle}</style>
      <Modal
        id="external-link-modal"
        className="external-link-modal"
        headerTitle="External Link"
        headerProps={{
          closeButtonIconProps: {
            spriteSheetHref: spritePath,
          },
          element: "h5",
        }}
        theme="wss"
        primaryButtonText="Visit Link"
        aria-label="External Link"
        footerProps={{
          primaryButtonProps: {
            onClick: () => visitLink(externalLink),
          },
          secondaryButtonText: "Go Back",
          secondaryButtonProps: {
            onClick: () => Modal.close("external-link-modal"),
          },
        }}
      >
        <p>
          You are about to leave the security of WebstaurantStore.com.
          <br />
          <br />
          We are not responsible for the privacy policy or any content, links or
          software, or any consequences from your access to or use of the
          technologies, websites, information and programs made available on
          this new site.
          <br />
          <br />
          Do you want to proceed?
        </p>
      </Modal>
    </>
  );
}
export default ExternalLinkModal;
